module.exports = __webpack_public_path__ + "img/gift.be5170de.png";